// usage
// All:  import * as tools from 'Tools';
// some: import { fetchJSON, fetchPOST, QueryString } from 'Tools';

export const QueryString = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop: string) => searchParams.get(prop),
});

export const dateTimeFormatConfig: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
};
export function addMultipleEventListener(element, events, handler) {
    events.forEach((e) => element.addEventListener(e, handler));
}

export const formatDate = (dt: Date) => {
    return dt.toLocaleDateString('de-DE', dateTimeFormatConfig);
};

/**
 * AJAX fetch JSON
 * @param url string
 * @returns
 */
export const fetchJSON = async (url: string) => {
    const response = await self.fetch(url);
    return response.json();
};

/**
 * AJAX fetch TEXT
 * @param url string
 * @returns
 */
export const fetchTEXT = async (url: string) => {
    const response = await self.fetch(url);
    return response.text();
};

/**
 * AJAX-POST
 * @param url
 * @param data
 * @param isJson
 * @returns
 */
export const fetchPOST = async (url: string, data: IDictionary, isJson = true) => {
    let formData = new FormData();
    for (let dataProperty in data) {
        if (data[dataProperty].files) {
            if (dataProperty.match('\\[\\]')) {
                for (let fIndex = 0; fIndex < (<FileList>data[dataProperty].files).length; fIndex++) {
                    formData.append(dataProperty, (<FileList>data[dataProperty].files)[fIndex]);
                }
            } else {
                formData.append(dataProperty, data[dataProperty].files[0]);
            }
        } else {
            formData.append(dataProperty, data[dataProperty]);
        }
    }
    const response = await fetch(url, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        credentials: 'same-origin', // include, *same-origin, omit
        // headers: {
        //     'Content-Type': 'multipart/form-data'
        //     // 'Content-Type': 'application/x-www-form-urlencoded',
        // },
        redirect: 'follow', // manual, *follow, error
        referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        body: formData, // body data type must match "Content-Type" header
        // body: JSON.stringify(data) // body data type must match "Content-Type" header
        // body: fd //JSON.stringify(data) // body data type must match "Content-Type" header
    });
    if (isJson) {
        return response.json(); // parses JSON response into native JavaScript objects
    }
    return response.text();
};
export const fetchPOSTjson = async (url: string, data: IDictionary, isJson = false) => {
    const response = await fetch(url, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        credentials: 'same-origin', // include, *same-origin, omit
        redirect: 'follow', // manual, *follow, error
        referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        body: JSON.stringify(data), // body data type must match "Content-Type" header
    });
    if (isJson) {
        return response.json(); // parses JSON response into native JavaScript objects
    }
    return response.text();
};

export const setDateInputNow = (element: HTMLInputElement, t = new Date()) => {
    function p(number) {
        return number.toString().padStart(2, '0');
    } //number to 2 digit, 0 padded string
    element.value = `${t.getFullYear()}-${p(t.getMonth() + 1)}-${p(t.getDate())}`;
};

export const setDateTimeInputNow = (element: HTMLInputElement, t = new Date()) => {
    function p(number) {
        return number.toString().padStart(2, '0');
    } //number to 2 digit, 0 padded string
    element.value = `${t.getFullYear()}-${p(t.getMonth() + 1)}-${p(t.getDate())}T${p(t.getHours())}:${p(t.getMinutes())}`;
};

/**
 * @desc Addiert zu jetzt, oder übergebenen Zeitpunkt
 *  - nD n Tage
 *  - nH n Stunden
 *  - nM n Minuten
 *
 * Beispiel:
 * `1D1H1M` addiert 1 Tag, 1 Stunde und 1 Minute zu now
 *
 * @param dateInterval
 * @param now
 * @returns Date
 */
export const setFuture = (dateInterval: string, now = new Date()) => {
    let m = dateInterval.match(/(\d+)(\w)/g);
    m.forEach((di) => {
        switch (true) {
            case /^(\d+)D/.test(di):
                now.setDate(now.getDate() + parseInt(di));
                break;
            case /^(\d+)H/.test(di):
                now.setHours(now.getHours() + parseInt(di));
                break;
            case /^(\d+)M/.test(di):
                now.setMinutes(now.getMinutes() + parseInt(di));
                break;
        }
    });
    return now;
};

export function isJson(str: string) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

export const getFormData = (container: HTMLElement) => {
    let fields = container.querySelectorAll('input, div.ckedit, select, textarea');
    let postData: IDictionary = {};
    fields.forEach((el: HTMLElement) => {
        if (el.hasAttribute('data-property')) {
            if (el.tagName === 'TEXTAREA') {
                postData[el.dataset.property] = (<HTMLTextAreaElement>el).value;
            }
            if (el.tagName === 'INPUT') {
                let elInput = <HTMLInputElement>el;
                if (elInput.type === 'file') {
                    if (elInput.value !== '') {
                        postData[el.dataset.property] = <HTMLInputElement>el;
                    }
                } else {
                    if ((elInput.type === 'checkbox' && elInput.checked) || elInput.type !== 'checkbox') {
                        if (el.dataset.property.match('\\[\\]')) {
                            let propName = el.dataset.property.replace('[]', '');
                            if (!postData[propName]) {
                                postData[propName] = [];
                            }
                            postData[propName].push(elInput.value);
                        } else {
                            postData[el.dataset.property] = elInput.value;
                        }
                    }
                }
            }
            if (el.tagName === 'SELECT') {
                // multiple?
                const selectEl = <HTMLSelectElement>el;

                if (selectEl.multiple) {
                    let selectedValue = [];
                    for (let i = 0; i < selectEl.options.length; i++) {
                        if (selectEl.options[i].selected) {
                            if (isJson(selectEl.options[i].value)) {
                                selectedValue.push(JSON.parse(selectEl.options[i].value));
                            } else {
                                selectedValue.push(selectEl.options[i].value);
                            }
                        }
                    }
                    postData[selectEl.dataset.property] = JSON.stringify(selectedValue);
                } else {
                    postData[selectEl.dataset.property] = selectEl.value;
                }
            }
            if (el.tagName === 'DIV') {
                let editor = CKEDITOR.instances[el.id];
                postData[el.dataset.property] = editor.getData();
            }
        }
    });
    return postData;
};

export const toggleCSSclasses = (el: HTMLElement, ...cls: Array<string>) => cls.map((cl) => el.classList.toggle(cl));
